
import { AuditModel, ProcessTypeEnum, TenantUserModel, PermissionTypeEnum } from '@/libs/Api';
import { auditsStore } from '@/libs/audits/+state/store';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { PermissionsHelper } from '@/libs/core/permissions-helper';
import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class AuditSelect extends Vue {
    tenantUser: TenantUserModel = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;

    @Prop({ default: '' }) label!: string;
    @VModel() innerValue!: string;
    @Prop() type!: string;
    @Prop() placeholder!: string;
    @Prop() readonly!: boolean;
    @Prop() rules!: [any[]];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) disabled!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: false }) hideDetails!: boolean;
    @Prop({ default: false }) all!: boolean;
    @Prop({ default: false }) multiple!: boolean;
    @Prop({ default: true }) chips!: boolean;
    @Prop({ default: null }) processType!: ProcessTypeEnum | ProcessTypeEnum[] | null;
    @Prop({ default: null }) categoryId!: string | Array<string> | null;
    @Prop({ default: () => [] }) requiredPermissions!: PermissionTypeEnum[];

    @Watch('innerValue')
    innerValueChanged(v: string) {
        this.$emit('change', v);
    }

    get items(): AuditModel[] {
        let audits = auditsStore.useGetter(CrudGetter.Data, 'AuditSelect') as AuditModel[];
        if (this.categoryId != null && typeof this.categoryId == 'string') {
            audits = audits.where((x) => x.categoryId == this.categoryId).toArray();
        } else if (this.categoryId && this.categoryId!.length > 0) {
            let result: Array<AuditModel> = [];
            audits.forEach((x: AuditModel) => {
                if (this.categoryId!.includes(String(x.categoryId))) {
                    result.push(x);
                }
            });
            audits = result;
        }
        if (this.processType != null) {
            if (Array.isArray(this.processType)) {
                audits = audits.filter((x) => this.processType!.includes(x.processType ?? ProcessTypeEnum.Audit));
            } else {
                audits = audits.filter((x) => x.processType == this.processType);
            }
        }
        return audits;
    }

    get loading(): boolean {
        return auditsStore.useGetter(CrudGetter.Data, 'AuditSelect');
    }

    mounted() {
        const query: CrudQueryPredicate[] = [];
        
        // Nový systém: filtrovat kategorie s kontextovými oprávněními
        if (!this.all && !this.tenantUser.accessAllCategories) {
            // Použij requiredPermissions prop, pokud je zadán, jinak výchozí oprávnění
            const permissions = this.requiredPermissions.length > 0 
                ? this.requiredPermissions 
                : [PermissionTypeEnum.PerformAudit, PermissionTypeEnum.Audits];
            
            const accessible = PermissionsHelper.getUserAccessibleCategoryIds(permissions);
            
            if (accessible.length > 0) {
                query.push({
                    field: 'categoryId',
                    op: 'in',
                    comparand: accessible,
                });
            } else {
                // Žádný přístup = prázdný výsledek
                query.push({ field: 'id', op: 'eq', comparand: '00000000-0000-0000-0000-000000000000' });
            }
        }
        
        auditsStore.dispatch(
            CrudAction.GetAll,
            createCrudQueryPayload<AuditModel>(
                { field: 'name', index: 1, order: 'asc' },
                query,
                undefined,
                false,
                'AuditSelect'
            )
        );
    }
}
